const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
type CombinedTabBeforeLoadArgs = {
  context: {
    flags: {
      enableCombinedPortfolioAndVisualizationsTab: boolean;
    };
  };
  params: {
    loopId: number;
    org: string;
  };
};
export const portfolioIndexBeforeLoad = ({
  context,
  params
}: CombinedTabBeforeLoadArgs) => {
  if (context.flags.enableCombinedPortfolioAndVisualizationsTab) {
    throw redirect({
      to: '/org/$org/loop/$loopId/portfolio/table',
      params,
      search: true,
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/')({
  beforeLoad: portfolioIndexBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});